<template>
    <MeasurementItem
        v-if="measurement.value"
        :title="measurement.title"
        :datetime="measurement.lastUpdated"
        :link-to="measurement.link"
    >
        <template #icon>
            <BatteryIcon
                width="24"
                height="24"
                :battery-level-in-percent="100"
            />
        </template>

        <template #content>
            <h3>{{ $t('label', [valueFomatted]) }}</h3>
        </template>
    </MeasurementItem>
</template>

<script>
import { measurementHelper } from '../utils'
import BatteryIcon from './icons/BatteryIcon'
import MeasurementItem from './MeasurementItem'

export default {
    name: 'EvChargingEtaMeasurementItem',
    components: {
        BatteryIcon,
        MeasurementItem,
    },
    props: {
        measurement: {
            type: Object,
            required: true,
        },
    },
    computed: {
        valueFomatted() {
            return measurementHelper.converters.ev_charging_eta(
                this.measurement.value
            )
        },
    },
}
</script>

<i18n>
{
    "en": {
        "label": "Charging finished at {0}"
    },
    "de": {
        "label": "EV Ladung fertig am {0}"
    },
    "fr": {
        "label": "Charge terminée à {0}"
    },
    "it": {
        "label": "Ricarica completata alle {0}"
    }
}
</i18n>

<style lang="scss" scoped>
h3 {
    padding-bottom: 2px;
    padding-left: 0;
    font-size: 20px;
}
</style>
